import React from 'react';
import SecuritySection from './ui/SecuritySection';
import SecuritySeverityBadge from './ui/SecuritySeverityBadge';
import SecurityEmptyState from './ui/SecurityEmptyState';
import { IconActivity } from '../../ui/adminIcons';
import { formatTimestamp, getEventTypeLabel } from '../securityUtils';

export default function SecurityEventsTable({
  sectionRef,
  eventSeverityFilter,
  onClearFilter,
  filteredEvents,
}) {
  return (
    <SecuritySection
      title="Recent security events"
      icon={<IconActivity />}
      id="security-events-section"
      ref={sectionRef}
    >
      {eventSeverityFilter !== 'ALL' ? (
          <div className="vx-sec-events-filter">
            <SecuritySeverityBadge severity={eventSeverityFilter} />
            <span className="vx-sec-muted">Showing {eventSeverityFilter.toLowerCase()} events only</span>
            <button type="button" className="btn vx-sec-filter-clear" onClick={onClearFilter}>
              Clear filter
            </button>
          </div>
        ) : null}

        {filteredEvents.length > 0 ? (
          <div className="vx-sec-table-wrap admin-table">
            <table className="vx-sec-table">
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Type</th>
                  <th>Severity</th>
                  <th>IP address</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {filteredEvents.map((event, index) => (
                  <tr key={event.id || `${event.timestamp}-${event.ipAddress}-${index}`}>
                    <td>{formatTimestamp(event.timestamp)}</td>
                    <td>{getEventTypeLabel(event.eventType)}</td>
                    <td>
                      <SecuritySeverityBadge severity={event.severity} />
                    </td>
                    <td><code className="vx-sec-ip-code">{event.ipAddress}</code></td>
                    <td>{event.email || event.endpoint || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <SecurityEmptyState
            title={
              eventSeverityFilter === 'ALL'
                ? 'No recent security events'
                : `No ${eventSeverityFilter.toLowerCase()} events in the recent feed`
            }
          />
        )}
    </SecuritySection>
  );
}
